import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';

interface Usuario {
  id: number;
  nome: string;
  login: string;
  cnpj: string;
  ativo: boolean;
}

@Component({
  selector: 'app-cadastro-usuario-operadora',
  templateUrl: './cadastro-usuario-operadora.component.html',
  styleUrls: ['./cadastro-usuario-operadora.component.scss']
})
export class CadastroUsuarioOperadoraComponent implements OnInit {
  usuarioForm: FormGroup;
  isEditing = false;
  usuarios: Usuario[] = [];
  dtOptions: DataTables.Settings = {};

  constructor(private fb: FormBuilder) {
    this.usuarioForm = this.fb.group({
      nome: ['', Validators.required],
      login: ['', Validators.required],
      cnpj: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarUsuarios();
  }

  carregarUsuarios() {
    // Mock data - substituir por chamada à API
    this.usuarios = [
      {
        id: 1,
        nome: 'Cliente A',
        login: 'cliente_a',
        cnpj: '12.345.678/0001-90',
        ativo: true
      },
      {
        id: 2,
        nome: 'Cliente B',
        login: 'cliente_b',
        cnpj: '98.765.432/0001-10',
        ativo: true
      },
      {
        id: 3,
        nome: 'Cliente C',
        login: 'cliente_c',
        cnpj: '45.678.901/0001-23',
        ativo: false
      }
    ];
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (!this.isEditing) {
      this.usuarioForm.reset();
    }
  }

  onSubmit() {
    if (this.usuarioForm.valid) {
      console.log('Form submitted:', this.usuarioForm.value);
      // Implementar lógica de salvamento
      this.isEditing = false;
      this.usuarioForm.reset();
    }
  }

  editarUsuario(usuario: Usuario) {
    this.isEditing = true;
    this.usuarioForm.patchValue({
      nome: usuario.nome,
      login: usuario.login,
      cnpj: usuario.cnpj
    });
  }

  inativarUsuario(usuario: Usuario) {
    usuario.ativo = !usuario.ativo;
    // Implementar lógica de ativação/desativação
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      console.log('File selected:', file);
      // Implementar lógica de upload
    }
  }
} 